import { useTranslation } from 'react-i18next'

import { getMockCalendarItems } from '../../Calendar.mock'

import {
  toCalendarGridDayLoads,
  toCalendarGridItem,
} from './useCalendarItemsLoader.utils'

export function useCalendarItemsLoader(filters) {
  const { t } = useTranslation()

  // TODO: read the items from the calendar items endpoint once the backend
  // serves it.
  async function getItems({ from, timezone, to }) {
    const { data } = await getMockCalendarItems({
      ...filters,
      from,
      timezone,
      to,
    })

    return {
      dayLoads: toCalendarGridDayLoads({ dayLoad: data.day_load, t }),
      items: data.items.map(item => toCalendarGridItem({ item, t, timezone })),
      meta: { taskTypesEnabled: data.settings_hint.task_types_enabled },
    }
  }

  return { getItems }
}
